import { Chip } from '../primitives';

/**
 * FilterChip — тонкая обёртка над `Chip` primitive (stage 00b).
 *
 * Figma source: `chips` component-set `5:175`, variants state=default (5:168)
 * и state=selected (5:173). Все tokens + state-классы живут в `Chip`
 * primitive — сюда ничего не копируем, чтобы не дублировать стили.
 *
 * FilterChip добавляет только семантическую обёртку с явным `label` prop
 * (вместо children), чтобы в каталоге / rubric-панелях было чище читать.
 *
 * Props:
 *   - label    — string
 *   - selected — boolean
 *   - onClick  — function
 */
export default function FilterChip({ label, selected, onClick }) {
  return (
    <Chip selected={selected} onClick={onClick}>
      {label}
    </Chip>
  );
}
